import HolidaysAPI from '../../api/holidays';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getHolidays: $state => $state.records || [],
  getUIFlags: $state => $state.uiFlags,
  getUpcomingHolidays: $state => {
    const records = $state.records || [];
    const today = new Date();
    const thirtyDaysLater = new Date(today);
    thirtyDaysLater.setDate(thirtyDaysLater.getDate() + 30);
    return records.filter(h => {
      const holidayDate = new Date(h.date);
      return holidayDate >= today && holidayDate <= thirtyDaysLater;
    });
  },
};

const actions = {
  async get({ commit }, { accountId }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await HolidaysAPI.get(accountId);
      commit('SET_HOLIDAYS', data.payload);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },
  async create({ commit }, { accountId, ...holidayData }) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await HolidaysAPI.create(accountId, holidayData);
      commit('ADD_HOLIDAY', data);
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },
  async update({ commit }, { accountId, id, ...holidayData }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await HolidaysAPI.update(accountId, id, holidayData);
      commit('UPDATE_HOLIDAY', data);
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },
  async delete({ commit }, { accountId, id }) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await HolidaysAPI.delete(accountId, id);
      commit('REMOVE_HOLIDAY', id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};

const mutations = {
  SET_HOLIDAYS($state, holidays) {
    $state.records = holidays;
  },
  ADD_HOLIDAY($state, holiday) {
    $state.records.push(holiday);
    $state.records.sort((a, b) => new Date(a.date) - new Date(b.date));
  },
  UPDATE_HOLIDAY($state, holiday) {
    const idx = $state.records.findIndex(h => h.id === holiday.id);
    if (idx !== -1) $state.records.splice(idx, 1, holiday);
  },
  REMOVE_HOLIDAY($state, id) {
    $state.records = $state.records.filter(h => h.id !== id);
  },
  SET_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
};

export default { namespaced: true, state, getters, actions, mutations };
